<div class="price-list-links">
  <lx-price-lists-portal-application-form [company]="company" [applicationForms]="applicationForms"></lx-price-lists-portal-application-form>
  <lx-price-lists-portal-price-lists-popup title="Terms & Conditions" [company]="company">
    <lx-price-lists-portal-terms-and-conditions [company]="company"></lx-price-lists-portal-terms-and-conditions>
  </lx-price-lists-portal-price-lists-popup>
  <lx-price-lists-portal-price-lists-popup *ngIf="publicHolidays" title="Public Holidays" [company]="company">
    <lx-price-lists-portal-public-holidays [countryCode]="countryCode"></lx-price-lists-portal-public-holidays>
  </lx-price-lists-portal-price-lists-popup>
</div>
